var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.244,
    height: 25.288,
    viewBox: "0 0 21.244 25.288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006",
    transform: "translate(-1675.147 -243.409)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_844",
    "data-name": "Line 844",
    y2: 25.288,
    transform: "translate(1693.441 243.409)",
    fill: "none",
    stroke: "#99999e",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_845",
    "data-name": "Line 845",
    x1: 5.901,
    transform: "translate(1690.49 256.055)",
    fill: "none",
    stroke: "#99999e",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_846",
    "data-name": "Line 846",
    y2: 25.288,
    transform: "translate(1678.098 243.409)",
    fill: "none",
    stroke: "#99999e",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_847",
    "data-name": "Line 847",
    x1: 5.901,
    transform: "translate(1675.147 250.02)",
    fill: "none",
    stroke: "#99999e",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_848",
    "data-name": "Line 848",
    y2: 25.288,
    transform: "translate(1685.77 243.409)",
    fill: "none",
    stroke: "#99999e",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_849",
    "data-name": "Line 849",
    x1: 5.901,
    transform: "translate(1682.818 262.905)",
    fill: "none",
    stroke: "#99999e",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterImage);
export default __webpack_public_path__ + "static/media/FilterImage.e30fd10263874bd398513e7e7728c4a1.svg";
export { ForwardRef as ReactComponent };